import { FunctionComponent } from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';
import forkLoading from '../assets/fork-lottie.json';
import {Spinner} from "../pages/TA/components/Loader/Spinner.tsx";

const Style = styled.div`
    display: flex;
    height: 100vh;
    width: 100vw;
    align-items: center;
    justify-content: center;
    background-color: #fcfcfc;
    animation: animLoadingPage 333ms ease-in forwards;

    @keyframes animLoadingPage {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`;

const LoadingPage: FunctionComponent = () => {
    const isDineout = false;
    return (
        <Style>
            {isDineout ? (
                <Lottie
                    options={{
                        animationData: forkLoading,
                    }}
                    height={80}
                    width={80}
                />
            ) : (
                <Spinner />
            )}
        </Style>
    );
};

export default LoadingPage;
